module.exports = __webpack_public_path__ + "a31c1bf791ebdd6f000df03d411b5248.png";